<div *ngIf="staffEventSkeletonsLoading$ | async">Loading...</div>
<div *ngIf="staffEventSkeletonsLoaded$ | async">
  <ng-container *ngIf="staffEventTypes$ | async as staffEventTypes">
    <mat-accordion *ngIf="staffEventSkeletons$ | async as staffEventSkeletons">
      <mat-expansion-panel
        *ngFor="let staffEventSkeleton of staffEventSkeletons"
        (opened)="staffEventOpened(staffEventSkeleton)"
      >
        <mat-expansion-panel-header>
          {{ staffEventSkeleton.staffEventType }} - ({{
            staffEventSkeleton.startDateTimeUTC | momentDate | date : 'MM/dd/yyyy'
          }}-{{ staffEventSkeleton.endDateTimeUTC | momentDate | date : 'MM/dd/yyyy' }})
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <sd-portal-staff-event-audit-list
            #staffEventAuditList
            [staffEvent]="staffEventSkeleton"
            [loading]="(staffEventAuditsLoading$ | async) && (scheduledEventAuditsLoading$ | async)"
            [staffEventAudits]="staffEventAudits$ | async"
            [scheduledEventAudits]="scheduledEventAudits$ | async"
            [staffEventBusinessPersonLoading]="staffEventBusinessPersonAuditsLoading$ | async"
            [staffEventBusinessPersonAudits]="staffEventBusinessPersonAudits$ | async"
            (loadStaffEvent)="loadStaffEventAudits($event)"
            (loadScheduledEvent)="loadScheduledEventAudits($event)"
            (loadStaffEventBusinessPerson)="loadStaffEventBusinessPersonAudits($event)"
            (nextPage)="nextStaffEventAuditPage($event)"
            (nextStaffEventBusinessPersonPage)="nextStaffEventBusinessPersonAuditPage($event)"
            (nextScheduledEventPage)="nextScheduledEventAuditPage($event)"
          >
          </sd-portal-staff-event-audit-list>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
</div>
